/* eslint-disable */
export default {
  conferenceCall: '電話会議',
  onHold: '保留中',
  ongoing: '進行中',
  unknown: '不明',
  disconnected: '接続解除済み',
  loading: '読み込み中...',
  loadingTimeout: '読み込みがタイムアウトしました。',
} as const;

// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"ongoing"@#@ @source: @#@"Ongoing"@#@
// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"disconnected"@#@ @source: @#@"Disconnected"@#@
// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
// @key: @#@"loadingTimeout"@#@ @source: @#@"Loading timeout."@#@
